import styled from 'styled-components';

export const Wrapper = styled.div`
  background: var(--color-surface);
  width: 660px;
  padding: 30px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
`;
